<template>
  <custom-dialog
    :openDialog="isOpen"
    :widthDialog="'800px'"
    :classDialog="'create-dialog custome-dialog'"
    @closeDialog="$emit('closeDialog')"
    @closed="$emit('dialogClosed')"
  >
    <!--    <template #header>-->
    <!--      <h3 class="dialogTitle">Tìm kiếm nâng cao</h3>-->
    <!--    </template>-->

    <template #header>
      <h5 class="dialogTitle margin-left-10">
        Tìm kiếm nâng cao
      </h5>
    </template>

    <template #body>
      <el-form
        :model="advanceSearchForm"
        ref="form"
        label-position="left"
        label-width="100px"
      >
        <el-row :gutter="24">
          <el-col :span="24">
            <el-form-item label="Trích yếu" class="formItem">
              <el-input
                class="style-fullWidth input-border__bottom input-border__radius__0"
                v-model="advanceSearchForm.quote"
                size="medium"
                placeholder="Trích yếu"
              ></el-input>
            </el-form-item>
          </el-col>

          <el-col :span="12">
            <el-form-item label="Loại văn bản" class="formItem">
              <el-select
                clearable
                class="style-fullWidth input-border__bottom input-border__radius__0"
                v-model="advanceSearchForm.docTypeId"
                filterable
                placeholder="-"
              >
                <el-option
                  v-for="item in docTypes"
                  :key="item.id"
                  :label="item.categoryName"
                  :value="item.id"
                ></el-option>
              </el-select>

              <!--              <el-input-->
              <!--                class="style-fullWidth input-border__bottom input-border__radius__0"-->
              <!--                v-model="advanceSearchForm.docTypeId"-->
              <!--                size="medium"-->
              <!--                placeholder="Số ký hiệu"-->
              <!--              ></el-input>-->
            </el-form-item>
          </el-col>

          <el-col :span="12">
            <el-form-item label="Ngày văn bản" class="formItem">
              <el-date-picker
                v-model="createTimeRange"
                type="daterange"
                format="dd/MM/yyyy"
                class="style-fullWidth input-border__bottom input-border__radius__0 bg__transparent"
                :picker-options="dateQuickFilterOption"
                range-separator="_"
                start-placeholder="_"
                end-placeholder="_"
                align="right"
                :clearable="false"
                @change="createTimeRangeChanged"
              ></el-date-picker>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
    </template>

    <template #footer>
      <div class="flex-row flex__right form-button__action">
        <el-button class="dialogBtnPrimary" @click="search">
          <i class="fal fa-search font-size__small"></i>
          &nbsp;Tìm kiếm
        </el-button>
        <el-button class="btn__cancel btn-none__border" @click="reset"
          >Xóa
        </el-button>
      </div>
    </template>
  </custom-dialog>
</template>

<script>
import constants from "../../../constants";
import dateUtils from "../../../dateUtils";
import categoryViewService from "../../../services/categoryViewService";
import utils from "../../../services/utils";
import CustomDialog from "../../common/custom-dialog";

export default {
  name: "doc-out-achievement-advance-search-dialog",
  props: ["isOpen", "form"],
  components: {
    CustomDialog
  },

  computed: {},

  data() {
    return {
      createTimeRange: null,
      advanceSearchForm: {
        docTypeId: null,
        fromCreateTime: null,
        toCreateTime: null,
        quote: null
      },
      dateQuickFilterOption: null,
      docTypes: []
    };
  },

  created() {
    this.dateQuickFilterOption = utils.getDefaultDateQuickFilterOption();
    this.loadDocTypes();
    this.initForm();
  },

  methods: {
    loadDocTypes() {
      return categoryViewService
        .findAllByGroupCode(constants.CATEGORY_GROUP_CODE.DOC_TYPE)
        .then(response => (this.docTypes = response.data));
    },

    search() {
      this.$emit("doSearch", {
        docTypeId: this.advanceSearchForm.docTypeId,
        fromCreateTime: this.advanceSearchForm.fromCreateTime,
        toCreateTime: this.advanceSearchForm.toCreateTime,
        quote: this.advanceSearchForm.quote
      });
    },

    reset() {
      this.advanceSearchForm.docTypeId = null;
      this.advanceSearchForm.fromCreateTime = null;
      this.advanceSearchForm.toCreateTime = null;
      this.advanceSearchForm.quote = null;
      this.initDocDateRange();
    },

    createTimeRangeChanged() {
      utils.timeRangeChanged(this.createTimeRange, (from_, to_) => {
        this.advanceSearchForm.fromCreateTime = from_;
        this.advanceSearchForm.toCreateTime = to_;
      });
    },

    initForm() {
      this.advanceSearchForm.docTypeId = this.form.docTypeId;
      this.advanceSearchForm.fromCreateTime = this.form.fromCreateTime;
      this.advanceSearchForm.toCreateTime = this.form.toCreateTime;
      this.advanceSearchForm.quote = this.form.quote;
      this.initDocDateRange();
    },

    initDocDateRange() {
      if (
        !this.advanceSearchForm.fromCreateTime ||
        !this.advanceSearchForm.toCreateTime
      ) {
        utils.timeRangeChanged(
          (this.createTimeRange = dateUtils.getDatesByQuickFilter(
            constants.DATE_QUICK_FILTER.CODE.LAST_YEAR
          )),
          (from_, to_) => {
            this.advanceSearchForm.fromCreateTime = from_;
            this.advanceSearchForm.toCreateTime = to_;
          }
        );
      } else {
        this.createTimeRange = [
          new Date(this.advanceSearchForm.fromCreateTime),
          new Date(this.advanceSearchForm.toCreateTime)
        ];
      }
    }
  }
};
</script>

<style scoped></style>



// WEBPACK FOOTER //
// src/views/doc-out/achievement/doc-out-achievement-advance-search-dialog.vue